let onLoadModal = document.querySelector(".onLoadModal");

if (onLoadModal) {
	$(window).on('load', function() {
		$('.onLoadModal').modal('show');
	});
}
